/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_connect_bloque_description = /** @type {(inputs: {}) => string} */ () => {
	return `Ejecuta este comando en tu terminal para conectar tu agente de IA a Bloque. Configura la autenticación y le da a tu agente capacidades financieras.`
};

const en_onboarding_connect_bloque_description = /** @type {(inputs: {}) => string} */ () => {
	return `Run this command in your terminal to connect your AI agent to Bloque. It configures authentication and gives your agent financial capabilities.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_connect_bloque_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_connect_bloque_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_connect_bloque_description", locale)
	if (locale === "es") return es_onboarding_connect_bloque_description(inputs)
	return en_onboarding_connect_bloque_description(inputs)
};
export { onboarding_connect_bloque_description as "onboarding.connect_bloque.description" }